





















import Vue from 'vue';
import Component from 'vue-class-component';
import moment from 'moment-timezone';

@Component({})
export default class YouAreHere extends Vue {
  now = moment().format('MMM. D YYYY, HH:mm a');
}
